import {createSelector} from "reselect";
import {
	getGamesById,
	getPlayersById,
	isGamesLoaded,
	isPlayersLoaded,
} from "apps/BUDWEISERPOTM/modules/selectors";
import {getConfirmModalState, getVotes} from "apps/BUDWEISERPOTM/modules/selectors/votes";
import {intersection} from "lodash";
import {COUNTRIES_WITHOUT_BEER} from "apps/BUDWEISERPOTM/modules/constants";

export const isDataLoaded = createSelector(
	isGamesLoaded,
	isPlayersLoaded,
	(gamesLoaded, playersLoaded) => {
		return gamesLoaded && playersLoaded;
	}
);

export const getPlayersWithMinutes = createSelector(
	getPlayersById,
	getGamesById,
	(players, games) => (gameId: number) => {
		const game = games[gameId];
		if (!game) {
			return players;
		}
		return (
			game?.qualifiedPlayers?.map(({id, minutes}) => {
				const player = players[id];
				return {
					...player,
					minutes,
				};
			}) || players
		);
	}
);

export const isGameWithSponsor = createSelector(
	getConfirmModalState,
	getGamesById,
	(state, gamesById) => {
		if (!state) {
			return true;
		}
		const game = gamesById[state.gameId];
		if (!game) {
			return true;
		}
		return (
			intersection(COUNTRIES_WITHOUT_BEER, [game.homeSquadFeedId, game.awaySquadFeedId])
				.length === 0
		);
	}
);

export const getVotedPlayerForActualGame = createSelector(
	getVotes,
	getPlayersById,
	(votes, players) => (matchId: number) => {
		const vote = votes[matchId];
		return vote && vote.playerId ? players[vote.playerId] : null;
	}
);
